import axiosInstance from '@/utils/api.js'

var state = {
  oneTimeService: []
}

var getters = {
  ONE_TIME_SERVICE: (state) => {
    return state.oneTimeService
  }
}

var mutations = {
  SET_ONE_TIME_SERVICE: (state, payload) => {
    state.oneTimeService = payload || []
  }
}

var actions = {
  GET_ONE_TIME_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/once?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_ONE_TIME_SERVICE', result.data)
    }
  },
  CREATE_ONE_TIME_SERVICE: (context, payload) => {
    return axiosInstance.post('/tariffing/services/once', payload)
  },
  UPDATE_ONE_TIME_SERVICE: (context, payload) => {
    return axiosInstance.put('/tariffing/services/once', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/oneTimeService.js